module.exports = __webpack_public_path__ + "static/cf-med-italic-c03547c7209b311b24a474e0e7bbc6f6.eot";